export default "__VITE_ASSET__BfhZUHOn__"